import { ErrorType } from './ErrorType'

export class ApiError extends Error {
  type: ErrorType

  constructor(type: ErrorType) {
    super()
    this.type = type
  }
}

export class ApiValidationError extends Error {
  type: ErrorType

  constructor(type: ErrorType) {
    super()
    this.type = type
  }
}
